import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';

import AccessGate from './components/AccessGate';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import FileSources from './pages/FileSources';
import FileSourceDetail from './pages/FileSourceDetail';
import QuestionBases from './pages/QuestionBases';
import QuestionBaseDetail from './pages/QuestionBaseDetail';
import Agents from './pages/Agents';
import AgentDetail from './pages/AgentDetail';
import TestRuns from './pages/TestRuns';
import TestRunDetail from './pages/TestRunDetail';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AccessGate>
        <Router>
          <Box sx={{ display: 'flex' }}>
            <Sidebar />
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: 3,
                mt: 8,
                minHeight: '100vh',
                backgroundColor: 'background.default',
              }}
            >
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/file-sources" element={<FileSources />} />
                <Route path="/file-sources/:id" element={<FileSourceDetail />} />
                <Route path="/question-bases" element={<QuestionBases />} />
                <Route path="/question-bases/:id" element={<QuestionBaseDetail />} />
                <Route path="/agents" element={<Agents />} />
                <Route path="/agents/:id" element={<AgentDetail />} />
                <Route path="/test-runs" element={<TestRuns />} />
                <Route path="/test-runs/:id" element={<TestRunDetail />} />
              </Routes>
            </Box>
          </Box>
        </Router>
      </AccessGate>
    </ThemeProvider>
  );
}

export default App;
